var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","display":"block"}},[(_vm.title !== null)?_c('h3',{staticStyle:{"position":"absolute","top":"15px","left":"15px"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('canvas',{attrs:{"id":_vm.canvaID}})])}
var staticRenderFns = []

export { render, staticRenderFns }